export enum EProjectCreatorThirdStepForm {
  budgetType = 'budgetType',
  budgetAmount = 'budgetAmount',
  termEnd = 'termEnd',
  termStart = 'termStart',
  termChangeComment = 'termChangeComment'
}
